export const getTranslationResource = <K extends string = 'en'>(
  resource: Array<{ code: string; name: Record<'en' | K, string> }>,
  language: K,
): Record<string, string> => Object.fromEntries(resource.map((item) => [item.name.en, item.name[language]]));

export const getItemByCode = <K extends string = 'en'>(
  resource: Array<{ code: string; name: Record<'en' | K, string> }>,
  code: string,
): (typeof resource)[number] | undefined => resource.find((item) => item.code === code);
